import * as z from "zod";

export const CustomerSchema = z.object({
  Name: z.string(),
  Document: z.string(),
});
